import { Component, OnInit, Input } from '@angular/core';
import { GenderPerAgeChartData } from '../../../../../models/chart';
import {UserService} from '../../../../services/user.service';
import {CommonConstant, GenderEnum} from '../../../../app.constants';

@Component({
  selector: 'gender-per-age-chart',
  templateUrl: './gender-per-age-chart.component.html',
  styleUrls: ['./gender-per-age-chart.component.scss']
})
export class GenderPerAgeChartComponent implements OnInit {
  @Input() chartData: Array<GenderPerAgeChartData>;
  @Input() maxPercent: number;
  @Input() isPlaceholder: boolean | false;
  public leftXAxis: Array<number>;
  public rightXAxis: Array<number>;
  constructor(private userService: UserService) { }

  ngOnInit() {
    this.leftXAxis = [];
    for (let i = this.maxPercent; i >= 0; i--) {
      this.leftXAxis.push(i);
    }

    this.rightXAxis = [...this.leftXAxis];
    this.rightXAxis.reverse();
  }

  get barMaleColor() {
    return this.userService.chartColors[GenderEnum.MALE];
  }

  get barFemaleColor() {
    return this.userService.chartColors[GenderEnum.FEMALE];
  }

}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-demographics/gender-per-age-chart/gender-per-age-chart.component.ts